var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"alter"}},[(_vm.flag)?_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_c('div',[_c('img',{attrs:{"src":_vm.arr[_vm.type],"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.fn}},[_vm._v("×")])]),_c('p',[_vm._v(_vm._s(_vm.msg))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }